import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVisionPro: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="vision-pro, goggles"><path d="M12 15.125C9.44318 15.125 9.44318 18.25 5.86364 18.25C2.28409 18.25 0.75 15.125 0.75 12C0.75 6.27083 6.88636 5.74998 12 5.75C17.1136 5.75002 23.25 6.27083 23.25 12C23.25 15.0578 21.7159 18.25 18.1364 18.25C14.5568 18.25 14.5568 15.125 12 15.125Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round"/></CentralIconBase>;
};

export default IconVisionPro;
